import { ResultsItem, ResultSubItem, IconContent } from '../../../features/Report';
import { Tooltip, CustomData, CopyButton, Callout } from '../../../components';

export const TechnologiesSection = ({ id, data }) => {
  const defaultCriteria = {
    status: 'info',
    iconType: 'info',
    importance: { level: 0, text: '' },
    solvability: { level: 0, text: '' },
    isEmpty: true,
    message: 'Data is unavailable.',
    data: null,
  };

  const serverIp = data?.serverIp || defaultCriteria;
  const technologies = data?.technologies || defaultCriteria;
  const analytics = data?.analytics || defaultCriteria;
  const errorCount = data?.errorCount || 0;
  const toImproveCount = data?.toImproveCount || 0;

  return (
    <ResultsItem 
      id={id}
      title="Technologies" 
      tooltip="The technologies powering your site and digital marketing strategy can help your business make the most of SEO. That's why our SEO checker looks at your server, plus your website's technologies. These pieces of tech can range from essentials, like Google Analytics, to optional tools, like Facebook Pixel."
      errorCount={errorCount}
      toImproveCount={toImproveCount}
    >
      <ResultSubItem
        title="Server IP"
        tooltip="Your server IP is the address of the server that hosts your website. A server hosted near your target market's location can help improve server speed and content delivery times."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={serverIp?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!serverIp?.isEmpty && serverIp?.data?.ip && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {serverIp?.data?.cityName && (
                    <p className="text-primary">
                      <span className="text-strong">Server location:</span> {serverIp.data.cityName}
                    </p>
                  )}
                  <p className="text-secondary">
                    {serverIp.data.ip}
                  </p>
                </div>
                <Callout>
                  <p>A content delivery network (CDN) can help users access your website faster by delivering your content sooner via a network of geographically distributed servers.</p>
                </Callout>
              </div>
            )}
            
            {serverIp?.isEmpty && (
              <p className="text-primary">{serverIp?.message || 'Not identified.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Technologies"
        tooltip="Your technologies are the programs that power your site and website analytics. Common examples include Google Analytics, Facebook Pixel, and Google Optimize."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={technologies?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!technologies?.isEmpty && technologies?.data?.items?.length > 0 && (
              <div className="table-content-wrapper">
                <CustomData className="custom-data--scrollable" id="technologies-grid">
                  <div className="tech-grid">
                    {technologies.data.items.map((t, idx) => (
                      <div key={`${t.name}-${idx}`} className="tech-grid__item">
                        <span className="tech-grid__name">{t.name}</span>
                        <span className="tech-grid__category">{t.categoryLabel || t.category || ''}</span>
                      </div>
                    ))}
                  </div>
                </CustomData>
                <div className="copy-button-wrapper">
                  <CopyButton targetSelector="#technologies-grid" />
                </div>
              </div>
            )}
            
            {technologies?.isEmpty && (
              <p className="text-primary">{technologies?.message || 'No technologies were detected.'}</p>
            )}
          </IconContent>
        }
      />

      <ResultSubItem
        title="Analytics"
        tooltip="Web analytics let you measure visitor activity on your website. You should have at least one analytics tool installed, but It can also be good to install a second in order to cross-check the data."
        content={
          <IconContent
            icon={
              <Tooltip 
                iconType={analytics?.iconType || 'info'} 
                showTooltip={false} 
              />
            }
          >
            {!analytics?.isEmpty && analytics?.data?.items?.length > 0 && (
              <div className="table-content-wrapper">
                <CustomData className="custom-data--scrollable" id="analytics-grid">
                  <div className="tech-grid">
                    {analytics.data.items.map((a, idx) => (
                      <div key={`${a.name}-${idx}`} className="tech-grid__item">
                        <span className="tech-grid__name">{a.name}</span>
                      </div>
                    ))}
                  </div>
                </CustomData>
                <div className="copy-button-wrapper">
                  <CopyButton targetSelector="#analytics-grid" />
                </div>
              </div>
            )}
            
            {analytics?.isEmpty && (
              <p className="text-primary">{analytics?.message || 'No Analytics Technologies were found.'}</p>
            )}
          </IconContent>
        }
      />
    </ResultsItem>
  );
};
